import BaseService from './BaseService';
import entities from 'src/config/entities';

class TranslationService extends BaseService {

  constructor() {
    super({ entity: entities.TRANSLATION });
  }

  search(item, params) {
    let { locale, query } = params;
    let queryMatch = true;
    let localeMatch = true;
    if (query) {
      queryMatch = item.group.includes(query) || item.item.includes(query) || item.text.includes(query);
    }
    if (locale) {
      localeMatch = item.locale === locale
    }
    return queryMatch && localeMatch;
  }

  async get(params) {
    let result = await super.get(params);
    result.data = result.data.filter(item => this.search(item, params))
    result.total = result.data.length;
    return result;
  }
}

export default new TranslationService();
